import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "ui/components/dialog";
import { useEffect, useState } from "react";
import ButtonWithLoading from "@/components/button-with-loading";
import BookmarkForm from "./bookmark/form";
import { Form } from "react-crud-form";
import { useBookmarkForm } from "./bookmark/form/useBookmarkForm";
import { useNavigate, useParams } from "react-router-dom"
import { eventBus } from "utils/eventBus";
import { useForm } from "react-hook-form";

import { zodResolver } from "@hookform/resolvers/zod";
import bookmarkSchema from "./bookmark/form/schema";

export default function BookmarkDialog({ project_slug, bookmark_folder, handleClose }) {

  const { linkId } = useParams();
  const [showDialog, setShowDialog] = useState(false);

  const form = useForm({
    resolver: zodResolver(bookmarkSchema),
    defaultValues: {
      label: "",
      url: "",
      description: "",
      bookmark: bookmark_folder,
    },
  });



  const navigate = useNavigate();

  const handleDialogClose = (open) => {
    setShowDialog(open);
    if (!open) {
      eventBus.emit("refresh:list", `bookmark_links${project_slug}`);
      setShowDialog(false)
      navigate(`${handleClose}`);
    }
    console.log("handleDialogClose called");

    form.reset({
      label: "",
      url: "",
      description: "",
      bookmark: bookmark_folder,
    });
  };

  const { requiredFields, handleCreate, handleRead, handleUpdate } =
    useBookmarkForm({ bookmark_folder, handleDialogClose, form });

  const isCreateMode = location.pathname.endsWith("+");
  const isEditMode = !!linkId;

  useEffect(() => {
    if (isCreateMode) {
      setShowDialog(true);
      form.reset();
    }
    else if (isEditMode) {
      setShowDialog(true);
      handleRead(linkId);
    } else {
      setShowDialog(false);
      form.reset();
    }
  }, [isCreateMode, isEditMode]);

  return (
    <Dialog open={showDialog} onOpenChange={handleDialogClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {isEditMode ? "Edit Bookmark" : "Add Bookmark"}
          </DialogTitle>
        </DialogHeader>

        <Form
          form={form}
          create={handleCreate}
          read={handleRead}
          update={handleUpdate}
          itemId={linkId || "+"}
        >
          {({ createItem, updateItem, isNewItem }) => (
            <>
              <BookmarkForm form={form} requiredFields={requiredFields} />
              <DialogFooter>
                <div className="pt-4" >
                  {isNewItem ? (
                    <ButtonWithLoading variant="default" onClick={createItem}>Add</ButtonWithLoading>
                  ) : (
                    <ButtonWithLoading variant="default" onClick={updateItem}>Update</ButtonWithLoading>
                  )}
                </div>
              </DialogFooter>
            </>
          )}
        </Form>

      </DialogContent>
    </Dialog>
  );
}
